import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    ThemeProvider,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";//FB 6997    //FB 8338
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    GetMessageReplies,
    GetAdminSettingValue,
    GetClinicalDocuments,
    GetDocumentHTML,
    GetResultDocuments,
    InsertPPLogs,
} from "../../../../api";   //FB 8338  //FB 10390 //FB 10088
import NavBar from "../../../../components/Navbar";
import { ClinicalDocument } from "../../../../store";
import UseStyle from "../../../../css/styles";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingButton } from "@mui/lab";
//FB 8338
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from '@mui/icons-material/Print';

// Update log
// FB  6192   02/06/2023  DK  Added page to handle clinical documents
// FB  6904   05/31/2023  DK  Link is not bold on Clinical documents
// FB  6997   10/09/2023  SK   Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  7787   11/30/2023  DK  Incorrect date is being posted on portal
// FB  8338   02/23/2024  DK  Clinical docs taking so long to load
// FB  7681   03/04/2024  KI  Orady - need gear icon on mobile when the doc or any pages are loading
// FB  8584   05/14/2024  SK  Portal Loading takes long for multiple tabs
// FB  10077  02/13/2025  SK  Patient Portal Issues 2.6.25
// FB  10390  04/15/2025  DK  Cures Act compliance
// FB  10088  05/15/2025  GS  Allow to send the message from EMR to portal only

export default function ClinicalDocuments() {
    const matches = useMediaQuery("(min-width:600px)");
    const styles = UseStyle();
    const navigate = useNavigate();
    const [docs, setDocs] = useState<ClinicalDocument[]>();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rowsArray, setRowsArray] = useState([10, 15, 20]);
    //FB 8338
    const [viewLoaderArray, setViewLoaderArray] = useState<Array<number>>([]);
    const [pdfLoaderArray, setPDFLoaderArray] = useState<Array<number>>([]);
    const [printLoaderArray, setPrintLoaderArray] = useState<Array<number>>([]);
    const [open, setOpen] = useState(false);
    const [docHTMl, setDocHTMl] = useState("");
    const [selectedDocName, setSelectedDocName] = useState("");
    const [messageForUnsignedNotes, setMessageForUnsignedNotes] = useState("");   //FB 10390
    const [messageForCuresAct, setMessageForCuresAct] = useState("");   //FB 10390
    const [enableUnsignedSessions, setEnableUnsignedSessions] = useState(false);   //FB 10390
    const [isAllowReplies, setAllowReplies] = useState(true);//FB 10088
    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const stylestop = {
        container: {
            width: matches == false ? "250" : "567px",
            border: "1px grey",
            backgroundColor: "white",
            padding: matches == false ? "32px 16px" : "32px 40px",
            height: "auto",
        },
    };

    async function GetClinicalDocs() {
        //FB 10390 Start
        let enable_unsigned_sessions = await GetAdminSettingValue("Enable_Portal_Visibility_For_Unsigned_Sessions");
        setEnableUnsignedSessions(enable_unsigned_sessions.toString().toLowerCase() == "true" ? true : false);
        let pending_review_message = await GetAdminSettingValue("Provider_Pending_Review_Message");
        setMessageForUnsignedNotes(pending_review_message);
        let cures_act_message = await GetAdminSettingValue("Cures_Act_Compliance_Message");
        setMessageForCuresAct(cures_act_message);
        //FB 10390 End
        var data = sessionStorage.getItem("user");
        if (data != null) {
            const user = JSON.parse(data);
            if (user.EMRID != null) {
                const data = await GetClinicalDocuments(user.EMRID);
                setDocs(data);
            }
        }
    }

    //FB 8338 - Start
    async function LoadDocument(doc: any) {
        setPDFLoaderArray([...pdfLoaderArray, doc.SESSION_N]);
        const data = await GetResultDocuments(doc.SESSION_N);
        if (data != undefined) {
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            var filename = patientName + "_" + new Date().getTime() + ".pdf";
            var element = document.createElement("a");
            element.setAttribute("href", fileURL);
            element.setAttribute("download", filename);
            element.dataset.downloadurl = [
                "application/pdf",
                element.download,
                element.href,
            ].join(":");
            element.draggable = true;
            element.classList.add("dragout");
            element.click();
            //window.open(fileURL);
        }
        setPDFLoaderArray(pdfLoaderArray.filter((la) => la != doc.SESSION_N));
        InsertPPLogs(
            "Downloading clinical documents",
            window.location.href,
            userName,
            ""
        );
    }

    async function ViewDocument(document: any) {
        setViewLoaderArray([...viewLoaderArray, document.SESSION_N]);
        const data = await GetDocumentHTML(document.SESSION_N);
        if (data != undefined && data != "") {
            setSelectedDocName(document.CATEGORY_LABEL);
            setDocHTMl(data);
            setOpen(true);
        }
        setViewLoaderArray(viewLoaderArray.filter((la) => la != document.SESSION_N));
        InsertPPLogs(
            "Viewing clinical documents",
            window.location.href,
            userName,
            ""
        );
    }

    async function PrintDocument(doc: any) {
        setPrintLoaderArray([...printLoaderArray, doc.SESSION_N]);
        const data = await GetResultDocuments(doc.SESSION_N);
        if (data != undefined) {
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            var iframe = document.createElement('iframe'); //load content in an iframe to print later
            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = fileURL;
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.focus();
                    iframe.contentWindow?.print();
                }, 1);
            };
        }
        setPrintLoaderArray(printLoaderArray.filter((la) => la != doc.SESSION_N));
        InsertPPLogs(
            "Printing clinical documents",
            window.location.href,
            userName,
            ""
        );
    }
    //FB 8338 - End

    let patientName = "User";
    let userName: any;
    let data = sessionStorage.getItem("user");
    if (data != null) {
        patientName = JSON.parse(data).PatientFirstName;
        userName = JSON.parse(data).Login;
    }
    async function InsertLogs() {
        InsertPPLogs("Viewing Clinical documents", window.location.href, userName, "");
    }

    //FB 6997 - Begin
    const [showSpinner, setShowSpinner] = useState(false);
    const theme = useTheme();
    const [messagesEnabled, setMessagesEnabled] = useState(false);// FB  10077
    //FB 6997 - End

    useEffect(() => {
        setShowSpinner(true);//FB 6997
        GetMessageReplies().then(setAllowReplies);//FB 10088
        // FB  10077 - Begin
        let setting = sessionStorage.getItem("enable_portal_dashboard_options");
        const values = setting?.split(',').map(Number) || [];
        setMessagesEnabled(values.includes(2));
        // FB  10077 - End
        GetClinicalDocs();
        InsertLogs();
        //FB 6997 - Begin
        setTimeout(() => {
            setShowSpinner(false);
        }, 3000);
        //FB 8584
        //FB 6997 - End
    }, []);

    return (
        <>
            {matches && <NavBar />}
            {!matches && (
                <div
                    className="row"
                    style={{
                        paddingLeft: "25px",
                        paddingTop: "16px",
                        backgroundColor: "#F5F5F5",
                        fontWeight: "bold",
                    }}
                >
                    Clinical Documents{" "}
                    <hr
                        style={{ height: "2px", border: "none", backgroundColor: "black" }}
                    ></hr>
                </div>
            )}
            <Grid
                container
                spacing={2}
                marginBottom="20px"
                marginTop="0.5px"
                style={
                    matches == false
                        ? {
                            backgroundColor: "#F5F5F5",
                        }
                        : {
                            paddingLeft: "80px",
                            backgroundColor: "#F5F5F5",
                        }
                }
            >
                <Grid
                    item
                    xs={12}
                    style={
                        matches == false
                            ? {
                                marginLeft: "16px",
                            }
                            : {}
                    }
                >
                    {" "}
                    {matches && (
                        <Typography variant="h5">
                            <b
                                style={{
                                    paddingTop: "20px",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                    lineHeight: "40px",
                                }}
                            >
                                Clinical Documents
                            </b>
                        </Typography>
                    )}
                    {matches && docs != undefined && docs.length > 0 ? (
                        <>
                            {/* FB  10077 - Begin */}
                            <Typography variant="subtitle1">
                                Clinical Documents are posted as soon as they are available.
                            </Typography>
                            {/* FB 10390 */}
                            <Typography variant="subtitle1" style={{ color: "red", display: enableUnsignedSessions ? "block" : "none" }}>
                                {messageForCuresAct}
                            </Typography>
                            {/* FB 10088 */}
                            {messagesEnabled && (
                            isAllowReplies ? (
                                <Typography variant="subtitle1">
                                    If you have any follow-up questions,Please <a href="/user/home/Messages">message</a> or{" "}
                                    <a href="#">call</a> our office.
                                </Typography>
                                ) : (
                                <Typography variant="subtitle1">
                                    If you have any follow-up questions, please <a href="#">call</a> our office.
                                </Typography>
                                ))}                               
                            {/* FB  10077 - End */}
                        </>
                    ) : (
                        <></>
                    )}
                </Grid>
                {docs != undefined && docs.length > 0 ? (
                    matches ? (
                        <Grid item>
                            {/* FB 8338 */}
                            <TableContainer
                                component={Paper}
                                sx={{ height: "510px", width: "100%", borderRadius: 0 }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    aria-label="sticky table"
                                    style={{ tableLayout: "fixed" }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontSize: "1.2rem" }}>
                                                <b>Date</b>
                                            </TableCell>
                                            <TableCell style={{ fontSize: "1.2rem" }}>
                                                <b>Description</b>
                                            </TableCell>
                                            {/* FB 8338 */}
                                            <TableCell style={{ fontSize: "1.2rem", textAlign: "center" }}>
                                                <b>Tools</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {docs?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((doc) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell>
                                                            {/* FB 7787 */}
                                                            {doc.SESSION_DATE}
                                                        </TableCell>
                                                        {/* FB 8338 Start*/}
                                                        <TableCell>
                                                            {/* FB 10390 */}
                                                            {doc.CATEGORY_LABEL} {doc.IS_NOTE_COMPLETE_FLAG == 0 ? "(" + messageForUnsignedNotes + ")" : ""}
                                                        </TableCell>
                                                        <TableCell style={{ textAlign: "center" }}>
                                                            <Tooltip title="View Document" placement="top-start">
                                                                <LoadingButton
                                                                    loading={viewLoaderArray.indexOf(doc.SESSION_N) > -1}
                                                                    loadingPosition="center"
                                                                    loadingIndicator={
                                                                        <CircularProgress
                                                                            size={20}
                                                                            style={{ color: "#083A4D" }}
                                                                        />
                                                                    }
                                                                    onClick={() => ViewDocument(doc)}
                                                                    startIcon={
                                                                        <VisibilityIcon style={{ color: viewLoaderArray.indexOf(doc.SESSION_N) > -1 ? "white" : "#083A4D" }} />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                            <Tooltip title="Download PDF" placement="top-start">
                                                                <LoadingButton
                                                                    className={styles.textbutton}
                                                                    style={{ padding: "0px" }}
                                                                    loading={
                                                                        pdfLoaderArray.indexOf(doc.SESSION_N) > -1
                                                                    }
                                                                    loadingPosition="center"
                                                                    loadingIndicator={
                                                                        <CircularProgress
                                                                            size={20}
                                                                            style={{ color: "#083A4D" }}
                                                                        />
                                                                    }
                                                                    onClick={() => LoadDocument(doc)}
                                                                    startIcon={
                                                                        <DownloadIcon style={{ color: pdfLoaderArray.indexOf(doc.SESSION_N) > -1 ? "white" : "#083A4D" }} />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                            <Tooltip title="Print Document" placement="top-start">
                                                                <LoadingButton
                                                                    className={styles.textbutton}
                                                                    style={{ padding: "0px" }}
                                                                    loading={
                                                                        printLoaderArray.indexOf(doc.SESSION_N) > -1
                                                                    }
                                                                    loadingPosition="center"
                                                                    loadingIndicator={
                                                                        <CircularProgress
                                                                            size={20}
                                                                            style={{ color: "#083A4D" }}
                                                                        />
                                                                    }
                                                                    onClick={() => PrintDocument(doc)}
                                                                    startIcon={
                                                                        <PrintIcon style={{ color: printLoaderArray.indexOf(doc.SESSION_N) > -1 ? "white" : "#083A4D" }} />
                                                                    }
                                                                />
                                                            </Tooltip>
                                                            {/* FB 8338 End*/}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    maxWidth: "1063px",
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={8} display="flex">
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item>
                                                <span className={styles.TablePagination_text}>
                                                    Show{" "}
                                                </span>
                                            </Grid>
                                            <Grid item>
                                                <select
                                                    value={rowsPerPage}
                                                    onChange={(e) => handleChangeRowsPerPage(e)}
                                                    style={{
                                                        color: "#083A4D",
                                                        borderRadius: "5px",
                                                        padding: "8px, 16px, 8px, 16px",
                                                    }}
                                                >
                                                    {rowsArray.map((rows) => (
                                                        <option value={rows}>{rows}</option>
                                                    ))}
                                                </select>
                                            </Grid>
                                            <Grid item>
                                                <span className={styles.TablePagination_text}>
                                                    {" "}
                                                    per page
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4} className={styles.flexend_Grid}>
                                        <IconButton
                                            onClick={() => setPage(page - 1)}
                                            disabled={page === 0}
                                            style={{ color: page === 0 ? "" : "#083A4D" }}
                                        >
                                            <PlayCircleOutlineIcon
                                                style={{ transform: "rotate(180deg)" }}
                                            />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => setPage(page + 1)}
                                            disabled={
                                                page >=
                                                Math.ceil(
                                                    (docs ? docs.length : 0) / rowsPerPage
                                                ) -
                                                1
                                            }
                                            style={{
                                                color:
                                                    page >=
                                                        Math.ceil(
                                                            (docs ? docs.length : 0) / rowsPerPage
                                                        ) -
                                                        1
                                                        ? ""
                                                        : "#083A4D",
                                            }}
                                        >
                                            <PlayCircleOutlineIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    ) : (
                        <Grid container style={{ paddingLeft: "16px" }}>
                            {docs?.map((elem: any) => (
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card>
                                        <CardContent>
                                            {/* FB 6904 */}
                                            {/* FB 7787 */}
                                            <Typography
                                                style={{ color: "#13607C" }}
                                            //onClick={() => LoadDocument(elem)} FB 7681
                                            >
                                                {elem.SESSION_DATE}
                                            </Typography>
                                            {/* FB 6904 */}
                                            <Typography style={{ color: "#13607C", fontWeight: "bold" }}>
                                                {elem.CATEGORY_LABEL}
                                            </Typography>
                                            {/* FB 8338 */}
                                            <Typography>
                                                <Tooltip title="View Document" placement="top-start">
                                                    <LoadingButton
                                                        loading={viewLoaderArray.indexOf(elem.SESSION_N) > -1}
                                                        loadingPosition="center"
                                                        loadingIndicator={
                                                            <CircularProgress
                                                                size={20}
                                                                style={{ color: "#083A4D" }}
                                                            />
                                                        }
                                                        onClick={() => ViewDocument(elem)}
                                                        startIcon={
                                                            <VisibilityIcon style={{ color: viewLoaderArray.indexOf(elem.SESSION_N) > -1 ? "white" : "#083A4D" }} />
                                                        }
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Download PDF" placement="top-start">
                                                    <LoadingButton
                                                        className={styles.textbutton}
                                                        style={{ padding: "0px" }}
                                                        loading={
                                                            pdfLoaderArray.indexOf(elem.SESSION_N) > -1
                                                        }
                                                        loadingPosition="center"
                                                        loadingIndicator={
                                                            <CircularProgress
                                                                size={20}
                                                                style={{ color: "#083A4D" }}
                                                            />
                                                        }
                                                        onClick={() => LoadDocument(elem)}
                                                        startIcon={
                                                            <DownloadIcon style={{ color: pdfLoaderArray.indexOf(elem.SESSION_N) > -1 ? "white" : "#083A4D" }} />
                                                        }
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Print Document" placement="top-start">
                                                    <LoadingButton
                                                        className={styles.textbutton}
                                                        style={{ padding: "0px" }}
                                                        loading={
                                                            printLoaderArray.indexOf(elem.SESSION_N) > -1
                                                        }
                                                        loadingPosition="center"
                                                        loadingIndicator={
                                                            <CircularProgress
                                                                size={20}
                                                                style={{ color: "#083A4D" }}
                                                            />
                                                        }
                                                        onClick={() => PrintDocument(elem)}
                                                        startIcon={
                                                            <PrintIcon style={{ color: printLoaderArray.indexOf(elem.SESSION_N) > -1 ? "white" : "#083A4D" }} />
                                                        }
                                                    />
                                                </Tooltip>
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )
                ) : (
                    <div className="card " style={stylesbegin.container}>
                        <div
                            className="row"
                            style={{
                                paddingTop: "32px",
                                paddingBottom: matches == false ? "265px" : "32px",
                                paddingLeft: "10px",
                                backgroundColor: "#F5F5F5",
                            }}
                        >
                            <div className="col-sm-6">
                                <div className="card" style={stylestop.container}>
                                    {/* <div className="card-body"> */}
                                    <label
                                        className="card-text"
                                        style={{
                                            fontFamily: "Inter",
                                            fontSize: "16px",
                                            fontWeight: 400,
                                            lineHeight: "24px",
                                            letterSpacing: "0em",
                                            textAlign: "left",
                                            paddingBottom: "91px",
                                            paddingTop: "52px",
                                            paddingLeft: matches == false ? "16px" : "40px",
                                            height: "24px",
                                        }}
                                    >
                                        When you receive Clinical documents, they will be shown here.
                                    </label>
                                    {/* </div> */}
                                </div>
                                {/* FB 6997 - Begin */}

                                {/* FB 8584 - Begin */}
                            </div>
                        </div>
                    </div>
                )}
            </Grid>
            {/* FB 8584 - End */}
            <ThemeProvider theme={theme}>
                <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
                    <DialogContent
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress style={{ color: "#083A4D" }} />
                    </DialogContent>
                </Dialog>
            </ThemeProvider>
            {/* FB 8584 - Deleted Unused Part of Code */}
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth={"lg"}>
                <DialogTitle>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                        <Typography variant="h6" style={{ color: "#083A4D" }}>
                            <br /><b>{selectedDocName + " preview"}</b>
                        </Typography>
                    </Grid>
                </DialogTitle>
                <DialogContent
                    style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center",
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: docHTMl }} />
                </DialogContent>
                <DialogActions>
                    <Button
                        className={styles.textbutton}
                        onClick={() => setOpen(false)}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const button = {
    container: {
        backgroundColor: "#083A4D",
        color: "white",
    },
};

const stylestart = {
    container: {
        border: "1px grey",
        padding: "40px",
    },
};

const table = {
    container: {
        padding: "20px",
        border: "white",
    },
};

const stylesbegin = {
    container: {
        border: "1px grey",
        backgroundColor: "#F5F5F5",
    },
};
